import CommentsData from '../../data/ReportCommentsData'

export async function fetchReportComments(chartId) {
  return await new Promise(resolve => {
    setTimeout(() => {
      resolve(
        chartId
          ? CommentsData.find(comment => comment.chartId === chartId)
          : CommentsData,
      )
    }, 1000)
  })
}
